import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("CourseDetailsWidget", {
  title: "Course Details",
  attributes: {
    course: {
      title: "Course",
      description:
        "If not selected, current Page is used, if this is not a course page, the widget is not rendered",
    },
  },
  properties: ["course"],
  propertiesGroups: [
    {
      title: "Customize Attributes",
      properties: [
        "value1",
        "value2",
        "value3",
        "value4",
        "value5",
        "value6",
        "value7",
        "value8",
        "value9",
        "value10",
      ],
      key: "customAttributes",
    },
    {
      title: "Course",
      component: ({ widget }) => {
        const page = widget.get("course") || widget.obj();
        if (!page || page.objClass() !== "CoursePage") {
          return (
            <div className="alert alert-warning">
              No Course selected or page is not a course page.
            </div>
          );
        }

        const attributes = [
          "additionalDeadlineInfo",
          "additionalCreditsInfo",
          "additionalLocationInfo",
          "additionalLangInfo",
          "additionalDegreeInfo",
          "additionalStartInfo",
          "additionalFormInfo",
          "additionalCourseWorkloadInfo",
          "additionalTuitionFeeInfo",
          "additionalOrientationInfo",
        ];
        return (
          <div className="scrivito_detail_content">
            <div className="alert alert-info">
              Editing this Data also changes the data of the selected course
              page or the page this widget is inserted at.
            </div>
            <div>
              {attributes.map((attr) => (
                <>
                  <div className="scrivito_detail_label">
                    <span className="data_item_title">{attr}</span>
                  </div>
                  <Scrivito.ContentTag
                    content={page}
                    attribute={attr}
                    className="bg-white py-1 px-2 mb-3 d-block rounded"
                  />
                </>
              ))}
            </div>
          </div>
        );
      },
      key: "courseTab",
    },
  ],
  initialContent: {
    headline: "Lorem Ipsum",
  },
});
